import React from "react";
import T from "prop-types";
import { Map, List } from "immutable";
import { withFormFields } from "MODULES/shared/decorators";
import * as F from "MODULES/shared/components/Forms/FormTypes";

export function IncomingAWB({
  lineItem,
  exchange_sale: { input: { value: exchangeSale } }
}) {
  if (!exchangeSale) {
    return false;
  }

  const receivingRecord =
    lineItem
      .get("receiving_records", List())
      .sortBy(r => new Date(r.get("created_at")))
      .last() || Map();

  return (
    <React.Fragment>
      <p>Incoming AWB #: {receivingRecord.get("awb_number")}</p>
    </React.Fragment>
  );
}

IncomingAWB.propTypes = {
  lineItem: T.instanceOf(Map).isRequired,
  exchange_sale: F.formField(F.boolInput).isRequired
};

export default withFormFields(IncomingAWB, ["exchange_sale"]);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Form/Summary/IncomingAWB.jsx